import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=4f78b648&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=4f78b648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78b648",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f78b648')) {
      api.createRecord('4f78b648', component.options)
    } else {
      api.reload('4f78b648', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=4f78b648&scoped=true&", function () {
      api.rerender('4f78b648', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/integrationapps/Index.vue"
export default component.exports